import * as React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import DrawerComponent from '../../components/DrawerComponent/DrawerComponent';
import SendIcon from '@mui/icons-material/Send';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import TablaUsuarios from './tablaUsuarios'; 
import CrearUsuario from './crearUsuarios'; 
import AppBarComponent from '../../components/AppBarComponent/AppBarComponent';

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

export default function Usuarios() {
  const [auth, setAuth] = React.useState(true);
  const [open, setOpen] = React.useState(true);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [modalOpen, setModalOpen] = React.useState(false);

  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleModalOpen = () => {
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen(false);
  };

  const handleFormSubmit = (values: any) => {
    console.log('Form values:', values);
  };
  const role = React.useMemo(() => {
    const encodedRole = localStorage.getItem('Role');
    if (!encodedRole) return '';
    try {
      return atob(encodedRole).toLowerCase().trim();
    } catch {
      return '';
    }
  }, []);
  const cargoId = React.useMemo(() => {
    const encodedCargoId = localStorage.getItem('CargoId');
    if (!encodedCargoId) return '';
    try {
      return atob(encodedCargoId).trim();
    } catch {
      return '';
    }
  }, []);
  const isAdmin = role === 'administrador' || role.includes('admin') || cargoId === '1';

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <AppBarComponent
        open={open}
        handleDrawerOpen={handleDrawerOpen}
        auth={auth}
        anchorEl={anchorEl}
        handleMenu={handleMenu}
        handleClose={handleClose}
        title="Usuarios"
      />
      <DrawerComponent open={open} handleDrawerClose={handleDrawerClose} />
      <Box component="main" sx={{ flexGrow: 2, p: 3 }}>
        <DrawerHeader />
        <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={12}>
              <Breadcrumbs aria-label="breadcrumb">
                <Link underline="hover" color="inherit" href="/dashboard">
                  Inicio
                </Link>
                <Typography color="text.primary">Usuarios del modulo proyectos</Typography>
              </Breadcrumbs>
            </Grid>
            {!isAdmin ? (
              <Grid item xs={12}>
                <Alert severity="warning">
                  Esta seccion es solo para administradores del modulo de proyectos.
                </Alert>
              </Grid>
            ) : (
              <>
                <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-start' }}>
                  <Button variant="contained" endIcon={<SendIcon />} onClick={handleModalOpen}>
                    Crear Usuario
                  </Button>
                </Grid>
                <Grid item xs={12}>
                  <TablaUsuarios /> 
                </Grid>
              </>
            )}
          </Grid>
        </Container>
      </Box>

      <CrearUsuario
        open={modalOpen}
        onClose={handleModalClose}
        onSubmit={handleFormSubmit}
      />
    </Box>
  );
}
